const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.theone-myanmar.com';

const getHeaders = () => {
  const token = localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

export const generate2FA = async () => {
  const res = await fetch(`${API_BASE_URL}/auth/2fa/generate`, {
    method: 'POST',
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error('Failed to generate 2FA QR code');
  return res.json();
};

export const turnOn2FA = async (code: string) => {
  const res = await fetch(`${API_BASE_URL}/auth/2fa/turn-on`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ code }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Invalid 2FA Code');
  }
  return res.json();
};

export const turnOff2FA = async () => {
  const res = await fetch(`${API_BASE_URL}/auth/2fa/turn-off`, {
    method: 'POST',
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error('Failed to disable 2FA');
  return res.json();
};